import { createReducer, on } from '@ngrx/store';
import { createOrUpdateWorkspaceFields } from '../actions/workspace.actions';
import { initialState } from '../types';
import { signOut } from '../../auth/actions/auth.actions';

export const workspaceReducer = createReducer(
  initialState,
  on(createOrUpdateWorkspaceFields, (state, { fields }) => ({
    ...state,
    fields: {
      ...state.fields,
      ...fields,
    },
  })),
  on(signOut, () => initialState) // Reset the state to initialState on signOut
);
